import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { setAffToken, setAffInfo } from "@/lib/affiliateApi";
import { formatApiError } from "@/lib/adminApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AffiliateLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/affiliate/login`, { username, password });
      setAffToken(data.access_token);
      setAffInfo(data.affiliate);
      toast.success(`Hola, ${data.affiliate.name}`);
      navigate("/afiliado");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "No se pudo iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-5">
      <div className="w-full max-w-md">
        <a href="/" className="mb-6 inline-flex items-center gap-2 text-sm text-gray-500 hover:text-brand-ink">
          <ArrowLeft className="h-4 w-4" /> Volver al sitio
        </a>
        <div className="rounded-3xl border border-gray-200 bg-white p-8 shadow-xl shadow-brand-ink/5 sm:p-10">
          <img src="/brand/logo.png" alt="OperaSafe.cl" className="h-11 w-auto" />
          <div className="mt-7 flex items-center gap-2 text-brand-ink">
            <Lock className="h-5 w-5 text-brand-gold" />
            <h1 className="font-display text-xl font-bold text-brand-ink">Portal de Afiliados</h1>
          </div>
          <p className="mt-2 text-sm text-gray-500">Ingresa con el usuario y clave que te entregó OperaSafe.cl.</p>

          <form onSubmit={submit} noValidate className="mt-7 space-y-4" data-testid="affiliate-login-form">
            <div className="space-y-1.5">
              <Label htmlFor="username" className="text-sm font-medium text-brand-ink">Usuario</Label>
              <Input
                id="username"
                data-testid="affiliate-username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="tu.usuario"
                className="h-11 border-gray-300 focus-visible:ring-1 focus-visible:ring-brand-yellow"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-sm font-medium text-brand-ink">Contraseña</Label>
              <Input
                id="password"
                data-testid="affiliate-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="h-11 border-gray-300 focus-visible:ring-1 focus-visible:ring-brand-yellow"
              />
            </div>
            <Button
              type="submit"
              data-testid="affiliate-login-button"
              disabled={loading}
              className="h-11 w-full rounded-full bg-brand-ink font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-brand-inkHover"
            >
              {loading ? <><Loader2 className="mr-2 h-5 w-5 animate-spin" /> Ingresando...</> : "Ingresar"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
